import { render } from "./DiscountsForm.vue?vue&type=template&id=32cdb38a&scoped=true"
import script from "./DiscountsForm.vue?vue&type=script&lang=js"
export * from "./DiscountsForm.vue?vue&type=script&lang=js"

import "./DiscountsForm.vue?vue&type=style&index=0&id=32cdb38a&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-32cdb38a"]])

export default __exports__